import { useEffect, useState } from 'react';
import { useLocation } from 'wouter';
import { fetchReviewToday } from '../lib/api.js';

export function ReviewEntryButton(): JSX.Element | null {
  const [, setLocation] = useLocation();
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchReviewToday(200)
      .then((q) => {
        if (!cancelled) setCount(q.total);
      })
      .catch(() => {
        if (!cancelled) setCount(0);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (count == null || count === 0) return null;
  return (
    <button
      type="button"
      onClick={() => setLocation('/review')}
      className="fixed left-1/2 -translate-x-1/2 bottom-[max(24px,env(safe-area-inset-bottom))] z-10 rounded-full bg-surface border border-border px-6 py-3 text-primary shadow-lg active:bg-surface-2"
    >
      <span className="text-sentence">今日复习 ({count})</span>
    </button>
  );
}
